fx.ns("repositories", class CustomColorsRepository extends fx.ModelArray {

    constructor(data)
    {
        super(data);
    }


    get colors()
    {
        return this.sort( this._sort );
    }

    get lastColor()
    {
        return this._lastColor || (this.colors && this.colors.length > 0 ? this.colors.getItemAt(0).color : "#000000");
    }

    _sort(color1, color2)
	{
        return (color1.position > color2.position) ? 1 : -1;
	}

    addColor(color, creationid)
    {
        let tColor = tinycolor(color);
        color = tColor.toHexString();

        if (tColor.getAlpha() < 1)
            return;

        let element = this.find({color : color});
        if (!element)    // update
        {
            
            if (!this.last || color != this.last.color)
            {
                element = new models.CustomColor({ color : color, creation_id : creationid, position : 0})
                this.addItemAt( 0, element );
            }
            else
                return;
        
        }
        else
        {
            // check if this color is in first 5 ones
            //if (this.indexOf(element) >= 5)
                this.moveItemAt(0, element);
            //else
            //{
                
            //    return;
            //}
        }

        while (this.length > 10)
        {
            let item = this.getItemAt(this.length - 1);
            this.removeItem(item);
            item.delete();
        }
            

        this._lastColor = element.color;
        //this._lastColor = null;
        
        this._sortColors(element);
    }

    _sortColors(element)
    {
        let previous = this.JSON();

        for (let i = 0; i < this.length; i++)
            this.getItemAt(i).position = i;
        
        //element.position = 0;

        let action = new fx.Action("sort", element, this);
        action.previous = previous;
        action.json = [];
        this.trigger({type:"updated", action : action});
    }
});